import { LoanApplicationCardFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/components/LoanApplicationCardFactory';
import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';
import { ProcessingStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ProcessingStatus';
import { FlexColumn } from '@/components/shared/components/FlexColumn';

interface ParallelStrategyProps {
  processingStrategyEntity: AbstractProcessingStrategyEntity;
  processingStatus: ProcessingStatus | null;
}

export const ParallelStrategy = ({ processingStrategyEntity, processingStatus }: ParallelStrategyProps) => {
  const loanApplications = processingStrategyEntity.loanApplications;
  const paymentMethodConditions = processingStrategyEntity.paymentMethodConditions;

  if (!loanApplications || !paymentMethodConditions) {
    return <div>Loading...</div>;
  }

  return (
    <FlexColumn gridGap={16}>
      {loanApplications.map((loanApplication) => {
        return (
          <LoanApplicationCardFactory
            key={loanApplication.id}
            loanApplication={loanApplication}
            processingStrategyEntity={processingStrategyEntity}
            paymentMethodConditions={paymentMethodConditions}
            processingStatus={processingStatus}
          />
        );
      })}
    </FlexColumn>
  );
};
